const getDefaultState = () => {
    return {
        namespaced: true,
        userInfo: {},
        token: "",
        cartNum: "",
    };
};
const state = getDefaultState();

const mutations = {
    // 更新用户信息
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo;
    },
};

const actions = {
    // 异步获取用户信息并缓存
    fetchUserInfo({ commit }, userId) {
        return new Promise((resolve) => {
            // 模拟异步请求
            setTimeout(() => {
                const userInfo = {};
                commit('SET_USER_INFO', userInfo); // 提交 mutation 更新状态
                resolve(userInfo);
            }, 1000);
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};